import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { post } from "../../helpers/api_helper";
import { registerUserSuccessful } from "../../store/actions";
import statecity from '../../assets/jsons/statecity.json'
import { toast } from "react-toastify";
const PageThree = (props) => {
  const [email, setEmail] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [inputFields, setInputFields] = useState([
    { companyName: '', start:'', end:'', role:'', location:'' }])
  useEffect(() => {
    getEmail();
    //  console.log('all state', );
    let stateOptions = [];
    Object.keys(statecity).map((item) => {
      stateOptions.push({ label: item, value: item });
    });
    setStateOptions(stateOptions);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [])

  useEffect(() => {
    if (selectedState) {
      const city = statecity[selectedState]
      let cities = [];
      city.map((item) => {
        cities.push({ label: item, value: item });
      });
      setCityOptions(cities);
    }
  }, [selectedState]);

  const getEmail = async () => {
    var data = await localStorage.getItem("authUser");
    if (data) {
      data = JSON.parse(data);
      setEmail(data?.email);
    }
  }


  const handleValidSubmit = (event, values) => {
    const experience = [
      {
        companyName: values.companyName,
        start: values.start,
        end: values.end,
        role: values.role,
        location: values.location
      }
    ]

    const body = {
      experience: inputFields,
      step: 2,
      email: props.email
    }
    console.log('step 1 before',values);

    post('/register', body)
      .then((json => {
        // console.log('register',json);
        if (json.statusCode == 200) {
           toast.success(json.message)
          props.onButtonClick("pagefour");
          props.registerUserSuccessful(json);

        }else{
          toast.error(json.error)
        }
      }))
  }

  const addFormfield = () => {
    let newfield = { companyName: '', start:'', end:'', role:'', location:'' };

    setInputFields([...inputFields, newfield])
  }

  const removeInput = (index) =>{
    let data = [...inputFields];
    data.splice(index, 1)
    setInputFields(data)
  }
  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
 }

  console.log('inputFields',inputFields)

  return (

    <>
      <AvForm
        onValidSubmit={(e, v) => {
          handleValidSubmit(e, v)
        }}
      >
        <Row>
          <Col lg={12}>
            <h3 className="heading-title">Experienced</h3>
          </Col>

          {
            inputFields.map((input, index) => {

              return (
                <Row key={index}>
                  <Col md={4} sm={6}>
                    <AvField type="text" name="companyName" onChange={e => handleFormChange(index, e)} label="Company Name" required/>
                  </Col>
                  <Col md={4} sm={6}>
                    <AvField

                      name="start"
                      placeholder="Start"
                      type="date"
                      label="Start"
                      onChange={e => handleFormChange(index, e)}
                      validate={{ max: { value: new Date() } }}
                      required
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <AvField

                      name="end"
                      placeholder="End"
                      type="date"
                      label="End"
                      onChange={e => handleFormChange(index, e)}
                      validate={{ max: { value: new Date() } }}
                      required
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <AvField type="text" name="role" onChange={e => handleFormChange(index, e)} label="Designation" required/>
                  </Col>
                  <Col md={7} sm={7}>
                    <AvField

                      name="location"
                      type="textarea"
                      label="Location"
                      onChange={e => handleFormChange(index, e)}
                      rows={1}
                      required
                    />
                  </Col>
                  {
                    inputFields.length >= 2 ? <Col className="remove_button" md={1}>
                    <Button onClick={()=>removeInput(index)}><AiOutlineClose /> Remove</Button>
                  </Col>:null
                  }
                </Row>
              )
            })
          }
          <Row>
            <Col lg={8}>
              <AvField type="checkbox" name="avFieldCheckbox" label="I agree that all the above information is accurate to the best of my knowledge." required/>
            </Col>
            <Col className="add_button" md={4}>
              <Button onClick={addFormfield}>+ Add</Button>
            </Col>
          </Row>
          <FormGroup className="btn_box">
            <Button
              onClick={() => props.onButtonClick("pagetwo")}
              className="common-btn back_m">Back</Button>
            <Button
              // onClick={()=>props.onButtonClick("pagefour")}
              type="submit"
              className="common-btn">Next</Button>
            {/* {
            nextStep &&  <Button
            onClick={() => onButtonClick("pagetwo")}
            className="common-btn">Next</Button>
           } */}
          </FormGroup>
        </Row>
      </AvForm>

    </>
  );
};

export default PageThree;
